import { render, staticRenderFns } from "./ProductAlternativePackagingUnits.vue?vue&type=template&id=527edc0e&scoped=true&lang=pug&"
import script from "./ProductAlternativePackagingUnits.vue?vue&type=script&lang=ts&"
export * from "./ProductAlternativePackagingUnits.vue?vue&type=script&lang=ts&"
import style0 from "./ProductAlternativePackagingUnits.vue?vue&type=style&index=0&id=527edc0e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527edc0e",
  null
  
)

export default component.exports